import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const SectionContent = ({ content, className = '', isCode = false }) => {
    if (!content) {
        return null;
    }

    // Si c'est du code, utilise le rendu code simple
    if (isCode) {
        return (
            <pre className={`bg-gray-800 p-3 rounded-md text-green-300 overflow-x-auto whitespace-pre-wrap ${className}`}>
                {content}
            </pre>
        );
    }

    // Utilise ReactMarkdown pour le rendu riche du contenu
    return (
        <div style={styles.contentContainer} className={className}>
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
                {content}
            </ReactMarkdown>
        </div>
    );
};

const styles = {
    contentContainer: {
        fontSize: '1em',
        lineHeight: '1.6',
        color: '#abb2bf',
        // Styles pour le markdown
        '& h1, & h2, & h3, & h4, & h5, & h6': {
            color: '#61dafb',
            marginTop: '1em',
            marginBottom: '0.5em',
        },
        '& p': {
            marginBottom: '1em',
        },
        '& code': {
            backgroundColor: '#3b4048',
            padding: '2px 4px',
            borderRadius: '3px',
            fontFamily: 'monospace',
            color: '#e06c75',
        },
        '& pre': {
            backgroundColor: '#1e1e1e',
            padding: '10px',
            borderRadius: '5px',
            overflowX: 'auto',
            marginBottom: '1em',
        },
        '& a': {
            color: '#61dafb',
            textDecoration: 'underline',
        },
        '& ul, & ol': {
            marginLeft: '20px',
            marginBottom: '1em',
        },
        '& li': {
            marginBottom: '0.5em',
        },
    },
};

export default SectionContent;
